__turbopack_context__.v({
  "body": "sidebarSlider-module-scss-module__PmUmDG__body",
  "closeButton": "sidebarSlider-module-scss-module__PmUmDG__closeButton",
  "confirmation": "sidebarSlider-module-scss-module__PmUmDG__confirmation",
  "confirmationCancelButton": "sidebarSlider-module-scss-module__PmUmDG__confirmationCancelButton",
  "confirmationMessage": "sidebarSlider-module-scss-module__PmUmDG__confirmationMessage",
  "confirmationTitle": "sidebarSlider-module-scss-module__PmUmDG__confirmationTitle",
  "footer": "sidebarSlider-module-scss-module__PmUmDG__footer",
  "header": "sidebarSlider-module-scss-module__PmUmDG__header",
  "headerWithShadow": "sidebarSlider-module-scss-module__PmUmDG__headerWithShadow",
  "isOpen": "sidebarSlider-module-scss-module__PmUmDG__isOpen",
  "overlay": "sidebarSlider-module-scss-module__PmUmDG__overlay",
  "panel": "sidebarSlider-module-scss-module__PmUmDG__panel",
});
